import { Stack, Button, Input } from '@chaser/components';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import CardSection from '../../../../components/CardSection';
import useUser from '../../../../hooks/useUser';
import usePush from '../../../../hooks/usePush';
import AccountService from '../../../../services/account-service';
import { useDispatch } from 'react-redux';
import { setUserData } from '../../../login/duck/actions/login';
import LabeledFieldWithError from '../../../../components/LabeledFieldWithError';
import useShortCode from '../../../../hooks/useShortCode';

const Profile = () => {
  const shortCode = useShortCode();
  const user = useUser();
  const dispatch = useDispatch();

  const { execute: saveProfile, loading } = usePush(AccountService.updateProfile, {
    successToast: 'Profile updated',
    errorToast: true,
  });

  return (
    <Stack>
      <CardSection title="Profile">
        <Formik
          initialValues={{
            firstName: user?.profile?.firstName || '',
            lastName: user?.profile?.lastName || '',
          }}
          validationSchema={Yup.object().shape({
            firstName: Yup.string()
              .required('First name is required')
              .min(2, 'First name must be at least 2 characters')
              .max(50, 'First name must be less than 50 characters')
              .matches(
                /^[a-zA-Z\s'-]+$/,
                'First name can only contain letters, spaces, hyphens, and apostrophes',
              )
              .trim(),
            lastName: Yup.string()
              .required('Last name is required')
              .min(2, 'Last name must be at least 2 characters')
              .max(50, 'Last name must be less than 50 characters')
              .matches(
                /^[a-zA-Z\s'-]+$/,
                'Last name can only contain letters, spaces, hyphens, and apostrophes',
              )
              .trim(),
          })}
          validateOnBlur={false}
          onSubmit={async ({ firstName, lastName }, actions) => {
            const [err, res] = await saveProfile({
              firstName,
              lastName,
              shortCode,
            });

            if (err) {
              actions.setSubmitting(false);
              return;
            }

            dispatch(
              setUserData({
                ...user,
                firstName,
                lastName,
                profile: {
                  ...user.profile,
                  firstName,
                  lastName,
                },
              }),
            );

            actions.setSubmitting(false);
          }}
        >
          {({ values, isValid }) => (
            <Form>
              <Stack gap="small">
                <LabeledFieldWithError
                  label="First name"
                  name="firstName"
                  as={Input}
                  placeholder="Enter your first name"
                  width="450px"
                />
                <LabeledFieldWithError
                  label="Last name"
                  name="lastName"
                  as={Input}
                  placeholder="Enter your last name"
                  width="450px"
                />
                <div>
                  <Button
                    disabled={!(values.firstName && values.lastName) || !isValid}
                    type="submit"
                    loading={loading}
                    appearance="secondary"
                  >
                    Save
                  </Button>
                </div>
              </Stack>
            </Form>
          )}
        </Formik>
      </CardSection>
    </Stack>
  );
};

export default Profile;
